// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18u0v77o{margin-left:var(--ds-space-025,2px)}
._19pkidpf{margin-top:0}
._1e0c1o8l{display:inline-block}
._2hwx1b66{margin-right:var(--ds-space-050,4px)}
._otyridpf{margin-bottom:0}
._p12f1osq{max-width:100%}
._s7n4t94y{vertical-align:1px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/InlineCard/common/inline-lozenge/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,mCAAmC;AAC9C,WAAW,YAAY;AACvB,WAAW,oBAAoB;AAC/B,WAAW,oCAAoC;AAC/C,WAAW,eAAe;AAC1B,WAAW,cAAc;AACzB,WAAW,kBAAkB","sourcesContent":["._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._19pkidpf{margin-top:0}\n._1e0c1o8l{display:inline-block}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._otyridpf{margin-bottom:0}\n._p12f1osq{max-width:100%}\n._s7n4t94y{vertical-align:1px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
